import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../App.css';

function Services() {
  const navigate = useNavigate();

  const handleContactClick = () => {
    navigate('/contact');
  };

  useEffect(() => {
    // Scroll to top on page load
    window.scrollTo(0, 0);
    
    // Update scroll progress indicator
    const updateScrollProgress = () => {
      const winScroll = document.body.scrollTop || document.documentElement.scrollTop;
      const height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
      const scrolled = (winScroll / height) * 100;
      const scrollBar = document.querySelector('.scroll-progress');
      if (scrollBar) {
        scrollBar.style.width = scrolled + '%';
      }
    };

    // Add event listener
    window.addEventListener('scroll', updateScrollProgress);
    
    // Clean up
    return () => window.removeEventListener('scroll', updateScrollProgress);
  }, []);

  return (
    <div className="w-full">
      {/* Scroll Progress Indicator */}
      <div className="scroll-progress"></div>
      
      {/* Hero Section */}
      <header className="bg-white">
        <div className="container">
          <div className="flex justify-between items-center py-8 flex-col-mobile">
            <div>
              <h1 className="mb-4">
                Our <span className="text-flame">Services</span>
              </h1>
              <p className="mb-8 text-gray-600">Comprehensive software solutions to fuel your business growth</p>
            </div>
            <div>
              <img src="/assets/our-services.png" alt="Our Services" />
            </div>
          </div>
        </div>
      </header>

      {/* Main Services Section */}
      <section className="section bg-gray-50">
        <div className="container">
          <h2 className="section-title">Core <span className="text-flame">Offerings</span></h2>
          <div className="flex justify-between flex-col-mobile mb-8">
            <div className="card text-center">
              <div className="mb-4">🔥</div>
              <h3 className="mb-4">Custom Software Development</h3>
              <p className="text-gray-600 mb-6">
                Tailor-made applications designed to address your specific business requirements and challenges.
                Our development team crafts scalable, secure, and efficient solutions.
              </p>
              <ul className="text-left mt-4 text-gray-600">
                <li>Enterprise Applications</li>
                <li>Mobile Apps (iOS & Android)</li>
                <li>Web Applications</li>
                <li>API Development & Integration</li>
              </ul>
            </div>
            <div className="card text-center">
              <div className="mb-4">🔥</div>
              <h3 className="mb-4">UX/UI Design</h3>
              <p className="text-gray-600 mb-6">
                Compelling user experiences that engage and delight. We combine aesthetic 
                appeal with functional design to create interfaces that users love.
              </p>
              <ul className="text-left mt-4 text-gray-600">
                <li>User Research</li>
                <li>Wireframing & Prototyping</li>
                <li>Responsive Design</li>
                <li>User Testing</li>
              </ul>
            </div>
            <div className="card text-center">
              <div className="mb-4">🔥</div>
              <h3 className="mb-4">DevOps Services</h3>
              <p className="text-gray-600 mb-6">
                Streamline your development pipeline with our DevOps expertise. 
                We help you deploy faster, more reliably, and with greater confidence.
              </p>
              <ul className="text-left mt-4 text-gray-600">
                <li>CI/CD Pipeline Setup</li>
                <li>Cloud Infrastructure</li>
                <li>Containerization</li>
                <li>Monitoring & Alerting</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Blockchain Section */}
      <section className="section bg-white">
        <div className="container">
          <div className="flex items-center flex-col-mobile mb-8">
            <div>
              <h3 className="mb-4">Blockchain Development</h3>
              <p className="mb-8 text-gray-600">
                Build secure, transparent, and decentralized applications with our blockchain expertise.
                From smart contracts to full-scale DApps, we help businesses leverage this revolutionary technology.
              </p>
              <ul className="mb-8 text-gray-600">
                <li>Smart Contract Development</li>
                <li>DApp Creation</li>
                <li>Tokenization</li>
                <li>Blockchain Integration</li>
              </ul>
              <button className="btn" onClick={handleContactClick}>Explore Solutions</button>
            </div>
            <div>
              <img src="/assets/blockchain.png" alt="Blockchain Solutions" className="rounded" />
            </div>
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="section bg-gray-50">
        <div className="container">
          <h2 className="section-title">Our <span className="text-flame">Process</span></h2>
          <div className="process-timeline">
            <div className="process-step">
              <div className="process-number">01</div>
              <h3>Discovery</h3>
              <p className="text-gray-600">We analyze your requirements and business objectives to define the scope.</p>
            </div>
            <div className="process-step">
              <div className="process-number">02</div>
              <h3>Planning</h3>
              <p className="text-gray-600">We create detailed specifications and project roadmap with clear milestones.</p>
            </div>
            <div className="process-step">
              <div className="process-number">03</div>
              <h3>Development</h3>
              <p className="text-gray-600">Our team builds your solution using agile methodologies with regular updates.</p>
            </div>
            <div className="process-step">
              <div className="process-number">04</div>
              <h3>Testing</h3>
              <p className="text-gray-600">Rigorous quality assurance ensures your solution works flawlessly.</p>
            </div>
            <div className="process-step">
              <div className="process-number">05</div>
              <h3>Deployment</h3>
              <p className="text-gray-600">We launch your solution and provide comprehensive training.</p>
            </div>
            <div className="process-step">
              <div className="process-number">06</div>
              <h3>Support</h3>
              <p className="text-gray-600">Ongoing maintenance and support to ensure long-term success.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action Section */}
      <section className="bg-flame text-white py-16 text-center">
        <div className="container">
          <h2 className="mb-4">Ready to Ignite Your Project?</h2>
          <p className="mb-8">Let's discuss how our services can transform your business.</p>
          <button className="btn btn-white" onClick={handleContactClick}>Contact Us Today</button>
        </div>
      </section>
    </div>
  );
}

export default Services; 